import { render, staticRenderFns } from "./LoanSummaryRecentTransactions.vue?vue&type=template&id=39af7cd6&scoped=true&"
import script from "./LoanSummaryRecentTransactions.vue?vue&type=script&lang=ts&"
export * from "./LoanSummaryRecentTransactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39af7cd6",
  null
  
)

export default component.exports